export default {"src":"/_next/static/media/vimeo.aca9cef3.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};